const EVENTS_EN = {
  accepted: "Offer accepted by the client",
  booking_auto_extended: "Automatic extension",
  booking_end: "Booking end request",
  booking_extension: "Extension request",
  break_repair: "Significant breakages",
  break_repair_2: "Small breakages",
  breakdown: "Breakdown",
  breakdown_electric: "Electrical breakdown",
  breakdown_engine: "Engine breakdown",
  breakdown_mecanic: "Mechanical breakdown",
  breakdown_other: "Other breakdown",
  canceled: "Canceled",
  closed: "Closed",
  confirmed: "Order confirmed",
  damages_third_parties: "Legal damage claim",
  delay_in_delivery: "Delivery delay",
  deliveryOn: "Delivery on",
  document_compliance: "Documents compliance",
  events: "{{count}} events",
  forgetting_extend: "Forgot to extend",
  forgetting_recover: "Forgot to recover",
  from_date: "Start",
  hours_record: "Hours record",
  immobilisation: "Immobilization",
  incompetent_operator: "Incompetent operator",
  inventory: "Inventory",
  keys: "Key/Code: loss/not communicated",
  machine_delivery: "Delivery",
  machine_retrieval: "Retrieval",
  missing_accessory: "Missing accessory",
  n1_control: "N1 Control",
  n2_control: "N2 Control",
  n3_control: "N3 Control",
  no_show: "Delivery: No Show",
  open: "Open",
  openEvents: "Open events",
  operator_change: "Operator change",
  other: "Other",
  other_delivery: "Other delivery",
  other_request: "Other request",
  quality_issue: "Bad condition equipment",
  retrievalOn: "Retrieval on",
  robbery_accessory: "Accessory theft",
  robbery_article: "Machine theft",
  sent: "Request received",
  to_date: "End",
  undeclared_use: "Undeclared use",
  validated: "Booking request validated",
  weather: "Bad weather",
  wrong_machine: "Equipment error",
  wrong_reclassification: "Incorrect machine selection",
} as const;

export default EVENTS_EN;
